/**
 * Loop class - a single loop of connected vertices that
 * make up the edges of one tier of the crown (on one side)
 * This is a helper class for the Gem class
 *
 * @class
 * @param {number} w - Width of the loop
 * @param {number} h - Height of the loop
 * @param {number} c - Corner radius of the loop
 * @param {number} z - Depth (z-coordinate) of the loop. Default is 0.
 * @returns {Loop} - Loop object
 *
 */

export class Loop {
  constructor(w, h, c, z = 0) {
    let corner = (Math.min(w, h) / 2) * c;

    let xA = -w / 2;
    let yA = -h / 2 + corner;
    let xB = -w / 2 + corner;
    let yB = -h / 2;
    let xC = +w / 2 - corner;
    let yC = -h / 2;
    let xD = +w / 2;
    let yD = -h / 2 + corner;
    let xE = +w / 2;
    let yE = +h / 2 - corner;
    let xF = +w / 2 - corner;
    let yF = +h / 2;
    let xG = -w / 2 + corner;
    let yG = +h / 2;
    let xH = -w / 2;
    let yH = +h / 2 - corner;

    this.vertices = [
      createVector(xA, yA, z),
      createVector(xB, yB, z),
      createVector(xC, yC, z),
      createVector(xD, yD, z),
      createVector(xE, yE, z),
      createVector(xF, yF, z),
      createVector(xG, yG, z),
      createVector(xH, yH, z),
    ];
  }
}
